import React from 'react';
import ProgramContainer from '../containers/ProgramContainer';
import { Helmet } from 'react-helmet'
import {FrameContainer} from '../styledComponents/layout'
import styled from 'styled-components';
import { EpisodeCardWrapper } from '../styledComponents/theme'
import EpisodeCard from '../components/Episode/EpisodeCard'

const ProgramWrapper = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
`;


const ProgramPage = (props) => {
  const program = props.pathContext.data;
  const {episodes } = props;
  program.episodes = episodes.filter(obj => obj.programId === program.programId)
  return (
    <FrameContainer>
      <Helmet
        title={program.title}
        meta={[
          {name: 'description', content: program.title+ ':'+ program.summary+':'+props.meta.description},
        ]}
      />
      <ProgramWrapper>
        <img src={program.thumbnailUrl} alt={program.title}/>
        <h1>{program.title}</h1>
        <p>{program.summary}</p>
      </ProgramWrapper>
      <hr/>
      <h2>エピソード一覧</h2>
      <EpisodeCardWrapper>
        {program.episodes.map(episode => (
          <EpisodeCard episode={episode} key={episode.episodeId} />
        ))}
      </EpisodeCardWrapper>
    </FrameContainer>
  );
};

export default ProgramPage;



// WEBPACK FOOTER //
// ./src/templates/program.js